import BigNumber from 'bignumber.js'
import { ethers } from 'ethers'
import React, { useCallback, useEffect, useState } from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { Button, Modal, Text } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import Input from 'components/Input'
import Loading2 from 'components/Loading/Img2'
import { useMultiMintSetAllowanceToMint, useCheckMultiMintAddressStatus, useMultiMintRevokeAllowanceToMint, useMultiMintSetMaxAllowanceToMint } from '../hooks/useSep20Factory'

const Label = styled(Text)`
  text-align: left;
  padding-left: 16px;
  margin-bottom: 5px;
`

const Loading2Wrapper = styled.div`
    text-align: center;
    padding: 25px 0;
`

const Loading2WrapperInner = styled.div`
    width: 128px;
    display: inline-block;
`

const Row = styled.div`
  margin-top: 20px;
  margin-bottom: 5px;
`;

const StatusPiece = styled(Text)`
  text-align: left;
  word-break: break-all;
  padding-left: 16px;
  max-width: 400px;
`

const MinterWrapper = styled.div`
  width: 400px;
  max-width: 100%;
  margin-bottom: 5px;
`

const ModalActions = styled(Row)`
  text-align: center;

  & > button {
    margin: 7px;
    max-width: 128px;
    vertical-align:middle;

    @media (max-width: 350px) {
      margin: 7px 0;
      max-width: none;
      width: 100%;
    }
  }
`

interface ModalProps {
  token: any
  onDismiss?: () => void
}

const MAX = ethers.constants.MaxUint256.toString();

const TheModal: React.FC<ModalProps> = ({ token, onDismiss }) => {
  const TranslateString = useI18n()

  const [pendingTx, setPendingTx] = useState(false)
  const [value, setNewValue] = useState('')
  const [address, setNewAddress] = useState('')
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    setNewValue(e.currentTarget.value);
    if (Web3.utils.isAddress(e.currentTarget.value)) {
      setNewAddress(e.currentTarget.value);
    } else {
      setNewAddress('');
    }
  }

  const status = useCheckMultiMintAddressStatus(token?.address, address);

  const isLoading = address && status?.a !== address;

  const renderValue = (v,s) => {
    if (v?.toString() === MAX) return TranslateString(1450, 'Unlimited');
    return `${new BigNumber(v).div(new BigNumber(10).pow(token?.decimals||0)).toFixed()} ${s}`;
  }

  
  const [val, setVal] = useState('0')
  useEffect(()=>{
    if (status) {
      if (status.l?.toString() === MAX) setVal("");
      else setVal(new BigNumber(status.l).div(new BigNumber(10).pow(token?.decimals||0)).toFixed())
    }
  },
  // eslint-disable-next-line
  [status])

  const handleValChange = (e: React.FormEvent<HTMLInputElement>) => setVal(e.currentTarget.value)

  const isValid = (input) => {
    const v = new BigNumber(input);
    return v.isGreaterThan(0)
  }

  const onSet = useMultiMintSetAllowanceToMint(token?.address);
  const handleSubmit = useCallback(async () => {
    try {
      setPendingTx(true)
      const txHash = await onSet(address, new BigNumber(val), token?.decimals);
      // user rejected tx or didn't go thru
      if (txHash) {
        setPendingTx(false)
      }
    } catch (e) {
      console.error(e)
    }
  }, [onSet, setPendingTx, address, val, token?.decimals])
  const onSetMax = useMultiMintSetMaxAllowanceToMint(token?.address);
  const onRevoke = useMultiMintRevokeAllowanceToMint(token?.address);

  return (
    <Modal title={TranslateString(1444, 'Set Minter & Allowance')} onDismiss={onDismiss}>
      <Label>{TranslateString(1452, 'Minter Address')}:</Label>
      <MinterWrapper><Input placeholder={TranslateString(597, 'Address')} value={value} onChange={handleChange} /></MinterWrapper>
      {
        isLoading ? (
          <Loading2Wrapper><Loading2WrapperInner><Loading2/></Loading2WrapperInner></Loading2Wrapper>
        ) : (
          status ? (
            <>
              <Row>
                <StatusPiece>{TranslateString(1445, 'Remaining Allowance')}: {renderValue(status.l,token?.symbol)}</StatusPiece>
                <StatusPiece>{TranslateString(1446, 'Total Minted')}: {renderValue(status.m,token?.symbol)}</StatusPiece>
              </Row>
              <Row>
                <Label>{TranslateString(1453, 'Allowance')}:</Label>
                <Input placeholder={TranslateString(1447, 'Allowance')} value={val} onChange={handleValChange} />
              </Row>
              <ModalActions>
                {
                  Number(status.l) > 0 ? (
                    <Button
                      disabled={pendingTx}
                      onClick={async () => {
                        setPendingTx(true)
                        await onRevoke(address)
                        setPendingTx(false)
                        onDismiss()
                      }}
                    >
                      {TranslateString(1448, 'Set To Zero')}
                    </Button>
                  ) : ""
                }
                {
                  status.l?.toString() === MAX ? "" : (
                    <Button
                      disabled={pendingTx}
                      onClick={async () => {
                        setPendingTx(true)
                        await onSetMax(address)
                        setPendingTx(false)
                        onDismiss()
                      }}
                    >
                      {TranslateString(1449, 'Set To Unlimited')}
                    </Button>
                  )
                }
                <Button
                  disabled={pendingTx || !isValid(val)}
                  onClick={async () => {
                    setPendingTx(true)
                    await handleSubmit()
                    setPendingTx(false)
                    onDismiss()
                  }}
                >
                  {TranslateString(320, 'Submit')}
                </Button>
              </ModalActions>
            </>
          ) : ""
        )
      }
    </Modal>
  )
}

export default TheModal

const Announce = styled(Text)`
  margin-bottom: 1em;
  text-align: left;
  max-width: 470px;
`

const Announce2 = styled(Text)`
  margin-top: 1em;
  text-align: center;
  max-width: 470px;
`
